import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppilicationListComponent } from './application/appilication-list/appilication-list.component';
import { AppraisalCycleComponent } from './appraisal-cycle/appraisal-cycle/appraisal-cycle.component';
import { EvaluationListComponent } from './evaluation/evaluation-list/evaluation-list.component';
import { ApprovalComponent } from './approval/approval/approval.component';
import { ManageApprovalComponent } from './approval/manage-approval/manage-approval.component';
import { EvaluationReportComponent } from './evaluation/evaluation-report/evaluation-report.component';
import { ModuleGuard } from 'src/app/shared/guards/module.guard';

const routes: Routes = [
  {
    path: 'manage-approval',
    component: ManageApprovalComponent
  },
  {
    path: 'approval',
    component: ApprovalComponent,
    canActivate: [ModuleGuard],
    data: {
      title: 'approval',
      modules: ['APPROVAL']
    },
  },
  {
    path: 'appraisal-cycle',
    component: AppraisalCycleComponent,
    canActivate: [ModuleGuard],
    data: {
      title: 'appraisal-cycle',
      modules: ['CYCLE']
    },
  },
  {
    path: 'application-list',
    component: AppilicationListComponent,
    canActivate: [ModuleGuard],
    data: {
      title: 'application-list',
      modules: ['OKR']
    },
  },
  {
    path: 'appraisal-list',
    component: AppilicationListComponent,
    data: {
      title: 'appraisal-list'
    }
  },
  // {
  //   path: 'approval-list',
  //   component: ApparaisalFormComponent,
  //   data: {
  //     title: 'approval-list'
  //   }
  // },
  {
    path: 'evaluation-list',
    component: EvaluationListComponent,
    canActivate: [ModuleGuard],
    data: {
      title: 'evaluation-list',
      modules: ['EVALUATION']
    }
  },
  {
    path: 'evaluation-report',
    component: EvaluationReportComponent,
    canActivate: [ModuleGuard],
    data: {
      title: 'evaluation-report',
      modules: ['EVALUATION REPORT']
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AppraisalRoutingModule { }
